import { BASENAME } from './config';
const API_URL = process.env.REACT_APP_DASHBOARD_API || 'http://localhost:8000/dashboard-api';

async function request(path, { method = 'GET', headers = {}, body } = {}) {
  const token = localStorage.getItem('dashboard_token');
  const isFormData = (typeof FormData !== 'undefined') && body instanceof FormData;
  const res = await fetch(`${API_URL}${path}`, {
    method,
    headers: {
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...headers,
    },
    body: body ? (isFormData ? body : JSON.stringify(body)) : undefined,
  });
  let data = null;
  try {
    data = await res.json();
  } catch (_) {
    // ignore parse errors for empty bodies
  }
  if (!res.ok) {
    if (res.status === 401) {
      localStorage.removeItem('dashboard_token');
      window.location.href = `${BASENAME || ''}/login`;
    }
    const message = (data && (data.detail || data.message)) || `Ошибка HTTP ${res.status}`;
    throw new Error(message);
  }
  return data;
}

export const api = {
  get: (path) => request(path),
  post: (path, body) => request(path, { method: 'POST', body }),
  put: (path, body) => request(path, { method: 'PUT', body }),
  delete: (path) => request(path, { method: 'DELETE' }),
};

export default API_URL;